import { render, staticRenderFns } from "./SeguimientoAlertas.vue?vue&type=template&id=0d76959c&scoped=true&"
import script from "./SeguimientoAlertas.vue?vue&type=script&lang=js&"
export * from "./SeguimientoAlertas.vue?vue&type=script&lang=js&"
import style0 from "./SeguimientoAlertas.vue?vue&type=style&index=0&id=0d76959c&scoped=true&lang=css&"
import style1 from "./SeguimientoAlertas.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d76959c",
  null
  
)

export default component.exports